import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    ChangeDeliveryDatePayload,
    UpdateCargoPayload,
    UpdateWavePayload
} from './types/invoice'

type ApiChangeDeliveryDateResponse = Promise<AxiosResponse<void>>
type ApiUpdateCargoResponse = Promise<AxiosResponse<void>>
type ApiSetWaveResponse = Promise<AxiosResponse<void>>

export function changeDeliveryDate(invoice_id: number, payload: ChangeDeliveryDatePayload): ApiChangeDeliveryDateResponse {
    return http.put(`/dispatcher/api/invoices/${invoice_id}/delivery-date`, payload)
}

export function updateCargoPayload(invoice_id: number, payload: UpdateCargoPayload): ApiUpdateCargoResponse {
    return http.put(`/cabinet/api/admin/invoices/${invoice_id}/update-cargo`, payload)
}

export function setWave(payload: UpdateWavePayload): ApiSetWaveResponse {
    return http.put('/dispatcher/api/invoices/set-wave', payload)
}

export default {
    changeDeliveryDate,
    updateCargoPayload,
    setWave
}
